import { useParams } from 'react-router';

import type { EFakturaPermissionId } from '../../../generated-types';

const useEfakturaPermissionId = (): EFakturaPermissionId | undefined => {
    const params = useParams<{ efakturaId: string }>();
    return params.efakturaId ? { value: params.efakturaId } : undefined;
};

export default useEfakturaPermissionId;
